import script from "./announcement-details.vue?vue&type=script&setup=true&lang=js"
export * from "./announcement-details.vue?vue&type=script&setup=true&lang=js"

import "./announcement-details.vue?vue&type=style&index=0&id=c109be64&scoped=true&lang=css"

import exportComponent from "/home/staging-tcms.qpax-tcms.net/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c109be64"]])

export default __exports__